/**
 * One of the three things allowed to loop (DECISION rule 8).
 *
 * A spinner says "this is being worked on" and nothing about how long. Work
 * of a known length gets a `ProgressBar` and a time instead; a list that is
 * loading gets a `Skeleton` in the shape of what is coming.
 *
 * With a `label` it is a live region and is announced; without one it is
 * decoration, and whatever it sits in (a button with `aria-busy`, a chip that
 * says "Training") carries the meaning.
 */
import { cx } from "./cx.js";
import "./spinner.css";

export interface SpinnerProps {
  /** sm 10px (inside a chip), md 14px (inside a button), lg 20px (on its own). */
  size?: "sm" | "md" | "lg";
  /** Announced to a screen reader. Omit when the surrounding element says it. */
  label?: string;
  className?: string;
}

export function Spinner({ size = "md", label, className }: SpinnerProps) {
  return (
    <span
      className={cx("mdl-spinner", className)}
      data-size={size}
      {...(label ? { role: "status", "aria-label": label } : { "aria-hidden": true })}
    />
  );
}
